import PropTypes from 'prop-types';

export default PropTypes.shape({
  avatarData: PropTypes.shape({
    fluid: PropTypes.object,
    title: PropTypes.string
  }),
  author: PropTypes.string,
  authorSubtitle: PropTypes.string,
  client: PropTypes.string,
  quote: PropTypes.string,
  imageData: PropTypes.shape({
    fluid: PropTypes.object,
    title: PropTypes.string
  }),
  type: PropTypes.string
})
